<script>
// Load component libraries and components
import Group from "./../primitives/Group.svelte";
import Textline from "./../primitives/Textline.svelte";

// Load libraries, modules and others


// Set model
export let label = "Etiqueta";
export let text = "Texto";
export let align = "left";
export let size = "3em";
export let labelSize = size;
labelSize = parseFloat(labelSize);
export let textSize = labelSize*0.8;
textSize = parseFloat(textSize);
export let color = "#FFFFFF"
export let margin = "0em";
export let weight = 600;
export let gap = "0em";
export let colorLabel = color
export let labelWeight = weight

// Set methods


// Other logic


</script>

<Group layout="column" justifyContent="space-around" alignContent="flex-start" alignItems="{align}" {margin}>
    <Textline text="{label}" {size} {color} {weight} {align} margin="0em 0em 1em 0em"></Textline>
    <Textline text="{text}" {labelSize} weight={labelWeight} color={colorLabel} opacity="0.8" {align}></Textline>
</Group>